<div class="selfview__warn-info-wrapper" [hidden]="!isTalkingWhenMuted">
    <div class="selfview__warn-info">
        {{ 'TOOLTIP.YOU_ARE_MUTED' | translate }}
    </div>
</div>
